import { Link } from "react-router-dom";
import "./breadcrumb.css";

export default function Breadcrumb({ items }) {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: item.url
        ? `https://chatel-guyon-hotel-cure-thermes.fr${item.url}`
        : undefined,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <nav className="breadcrumb" aria-label="Fil d'Ariane">
        <ol>
          {items.map((item, index) => (
            <li key={index}>
              {item.url ? (
                <Link to={item.url}>{item.label}</Link>
              ) : (
                <span aria-current="page">{item.label}</span>
              )}
              {index < items.length - 1 && <span className="separator">›</span>}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}
